import React from 'react';
import TabContainer from '../../../../../common/components/tab/containers/tab.containers';
import BookingBasicComponent from './order-booking-basic-info.component';

export const OrderBookingComponent = ({ jobs,shippingStatus,customers, salesOrders, selectedOrderBooking, onInnerBasicFormChange,back,handleFormSubmit}: any) => {
  const tabItems=[
    {
        id:1,
        title:'Booking Information',
        component:<BookingBasicComponent  
        jobs={jobs}
        shippingStatus={shippingStatus}
        customers={customers}
        salesOrders={salesOrders}
        selectedOrderBooking={selectedOrderBooking}
        onInnerBasicFormChange={onInnerBasicFormChange}  />,
    isVisible:true,
    },
  ,
  ]
  return (
    <div className="flex flex-col items-center w-full px-5 overflow-auto h-screen">
       
     
    <TabContainer tabItems={tabItems} />
 
    <div className='flex w-full justify-end items-end'>
      <button
            onClick={back}
            type='button'
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
           >
            Back
           </button>
           <button
          className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
            onClick={handleFormSubmit}
          
            type="submit"
        >
          Save
        </button>
      </div>
     </div>
  )
}
export default OrderBookingComponent;